/** @jsxImportSource @emotion/react */
import { Fragment } from "react";
import { Divider } from "primereact/divider";
import CampoInformacion from "../campoInformacion";

// Notas, norma (con sus acreditaciones), reglamentación y esquema de un tipo
// de certificado de la propuesta comercial. Recibe su entrada en
// precios.certificados del DTO de precios.
export default function InfoCertificadoPropuesta({ certificado, notas }) {
  const reglamentacion = certificado?.reglamentacion;
  const normas = certificado?.normas || [];
  const esquemas = certificado?.esquemas || [];

  const secciones = [];

  if (notas) {
    secciones.push(
      <div key="notas" className="grid">
        <CampoInformacion nombreCampo="Notas" anchoCompleto>
          {notas}
        </CampoInformacion>
      </div>
    );
  }

  if (normas.length || reglamentacion) {
    secciones.push(
      <div key="norma" className="grid">
        {normas.map((n) => (
          <Fragment key={n.id}>
            <CampoInformacion nombreCampo="Norma">
              {[n.numero, n.nombre].filter(Boolean).join(" - ")}
            </CampoInformacion>
            {n.acreditaciones?.length > 0 && (
              <CampoInformacion nombreCampo="Acreditación">
                {n.acreditaciones.map((a) => (
                  <div key={a.id}>
                    {`Acreditada por ${a.nombre}${a.pais ? ` (${a.pais})` : ""}`}
                    {a.linkAlcance && (
                      <>
                        {" - "}
                        <a href={a.linkAlcance} target="_blank" rel="noreferrer">
                          Alcance
                        </a>
                      </>
                    )}
                  </div>
                ))}
              </CampoInformacion>
            )}
          </Fragment>
        ))}
        {reglamentacion && (
          <CampoInformacion nombreCampo="Reglamentación">
            {reglamentacion}
          </CampoInformacion>
        )}
      </div>
    );
  }

  for (const e of esquemas) {
    secciones.push(
      <div key={`esquema-${e.id}`} className="grid">
        <CampoInformacion nombreCampo="Esquema">{e.etiqueta}</CampoInformacion>
        {e.descripcion && (
          <CampoInformacion nombreCampo="Descripción">
            {e.descripcion}
          </CampoInformacion>
        )}
        {e.detalles && (
          <CampoInformacion nombreCampo="Detalles" anchoCompleto>
            {e.detalles}
          </CampoInformacion>
        )}
      </div>
    );
  }

  // Cada sección va separada y la última también, de lo que venga después en
  // la card (la tabla de precios).
  return secciones.map((seccion) => (
    <Fragment key={seccion.key}>
      {seccion}
      <Divider />
    </Fragment>
  ));
}
